<template>
  <div class="home">
    <div class="header">
      <div class="logo">
        <img src="../assets/tono-live-logo.webp" alt="">
      </div>
      <div class="header-text">Tono Live</div>
    </div>
    <div class="banner">
      <div class="banner-content">
        <div class="title" data-text="A high-attractiveness live streaming social platform">
          A high-attractiveness live
          streaming social platform
        </div>
        <div class="slogan">Attractive live streams, sincere companionship 24/7 nonstop!</div>
        <div class="links">
          <router-link to="useragreement">User Agreement</router-link>
          <span class="divider">|</span>
          <router-link to="privacypolicy">Privacy Policy</router-link>
          <span class="divider">|</span>
          <router-link to="childsafetypolicy">Child Safety Policy</router-link>
        </div>
      </div>
      <div class="screenshot" v-if="imgLoaded">
        <img src="../assets/main.webp" alt="">
      </div>

      <div class="copyright">
        <p>Contact Us: <a href="mailto:hotfun2026@gmail.com">hotfun2026@gmail.com</a></p>
        <p>Copyright @ 2026 @ All Right Reserved MOTONG (HK) LIMITED</p>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HomeView',
  components: {},
  data() {
    return {
      imgLoaded: false
    }
  },
  created() {
    let webpImg = new Image();
    webpImg.src = require('../assets/main.webp')
    webpImg.onload = () => {
      this.imgLoaded = true
      webpImg = null
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  height: 100vh;
  background: url('../assets/flower-1.webp') no-repeat bottom left,
  url('../assets/flower-2.webp') no-repeat top right,
  linear-gradient(187deg, #FFADE4 5.41%, #FFF 81.48%);
  background-size: 20rem 20rem,
  20rem 20rem,
  100% 100%;
  position: relative;
  overflow: hidden;
}

.header {
  position: absolute;
  top: 20px;
  left: 67px;
  display: flex;
  align-items: center;
  z-index: 10;

  .logo {
    margin-right: 12px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    & > img {
      height: 32px;
      width: 32px;
      object-fit: contain;
    }
  }

  &-text {
    color: #000;
    font-family: "OPlus Sans SC 3.5";
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: 0.18px;
  }
}

.banner {
  background: transparent;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4.375rem 7.5rem 10rem 11rem;
  box-sizing: border-box;
  position: relative;
  min-height: 80vh;
  overflow: hidden;

  &-content {
    position: relative;
    width: 40.625rem;
    z-index: 3;
    margin-top: -8rem;
    background-image: url(../assets/hot-fun-live-text.webp);
    background-size: 37.75rem auto;
    background-repeat: no-repeat;
    background-position: top left;
    padding-top: 4.85rem;

    .title {
      position: relative;
      animation: fadeInUp 0.8s ease-out;
      letter-spacing: 0.02em;
      text-align: left;
      color: #000;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: "OPlus Sans SC 3.5";
      font-size: 3rem;
      font-style: normal;
      font-weight: 700;
      line-height: 3.25rem;
    }

    .slogan {
      margin-top: 2.25rem;
      color: #000000;
      font-family: OPlus Sans SC 3.5;
      font-weight: 500;
      position: relative;
      animation: fadeInUp 1s ease-out 0.2s both;
      text-align: left;
      font-size: 1.25rem;
      font-style: normal;
      line-height: 2.875rem;
      letter-spacing: 0.03125rem;
    }
  }

  .screenshot {
    user-select: none;
    display: flex;
    width: 34rem;
    margin-left: -5rem;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 3;
    animation: fadeInRight 1s ease-out 0.4s both;

    & > img {
      max-width: 100%;
      height: auto;
      display: block;
      filter: drop-shadow(0 0.625rem 1.875rem rgba(0, 0, 0, 0.1));
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      border-radius: 0.5rem;
    }

    & > img:hover {
      transform: translateY(-0.5rem) scale(1.03);
      filter: drop-shadow(0 0.9375rem 2.5rem rgba(0, 0, 0, 0.15));
    }
  }
}

.links {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0.5rem;
  position: absolute;
  margin-top: 9rem;
  margin-left: -2rem;
  font-size: 14px;
  font-weight: 500;

  a {
    color: #B236F8;
    font-family: OPlusSans 3.0;
    text-decoration: none;
    position: relative;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      color: #B236F8;
      opacity: 0.8;
    }
  }

  .divider {
    margin: 0 0.5rem;
    color: #B236F8;
    font-weight: 500;
  }
}

.copyright {
  position: absolute;
  bottom: 2rem;
  left: 50%;
  transform: translateX(-50%);
  padding-bottom: 0;
  color: rgba(0, 0, 0, 0.50);
  font-family: OPlusSans 3.0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;

  a {
    color: #B236F8;
    font-family: OPlusSans 3.0;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s ease;
    border-bottom: 1px solid transparent;

    &:hover {
      color: #B236F8;
      border-bottom-color: #B236F8;
    }
  }
}

// 动画定义
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(1.875rem);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(1.875rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pulse {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0.8;
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>